export default {
  step1: 'Register Seller Account    ',
  step2: 'Qualification Information',
  step3: 'Settlement Information',
  step4: 'Store Information',
  step5: 'Review Application'
}
